import React, { useEffect } from "react";

function Footer() {

    return (
        <div>
            <footer id="footer" className="footer bg-overlay">
                <div className="footer-main">
                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-lg-4 col-md-6 footer-widget footer-about">
                                <h3 className="widget-title">About Us</h3>
                                <img loading="lazy" className="footer-logo" src="assets/images/logo_white.png" alt="Adilite Group" />
                                <p style={{textAlign:'justify'}}>Welcome to Adilite Group, the leading provider of high-quality measurement and testing products.</p>
                                <div className="footer-social">
                                    <ul>
                                        <li><a href="#" aria-label="Facebook"><i className="fab fa-facebook-f" /></a></li>
                                        <li><a href="#" aria-label="Twitter"><i className="fab fa-twitter" /></a>
                                        </li>
                                        <li><a href="#" aria-label="Instagram"><i className="fab fa-instagram" /></a></li>
                                        <li><a href="#" aria-label="Github"><i className="fab fa-github" /></a>
                                        </li>
                                    </ul>
                                </div>{/* Footer social end */}
                            </div>{/* Col end */}
                            <div className="col-lg-4 col-md-6 footer-widget mt-5 mt-md-0">
                                <h3 className="widget-title">Working Hours</h3>
                                <div className="working-hours">
                                    We work 7 days a week, every day excluding major holidays. Contact us if you have an emergency, with our
                                    Hotline and Contact form.
                                    <br /><br /> Monday - Friday: <span className="text-right">10:00 AM - 6:00 PM </span>
                                    <br /> Saturday: <span className="text-right">10:00 AM - 6:00 PM</span>
                                    <br /> Sunday and holidays: <span className="text-right">10:00 AM - 1:00 PM</span>
                                </div>
                            </div>{/* Col end */}
                            <div className="col-lg-3 col-md-6 mt-5 mt-lg-0 footer-widget">
                                <h3 className="widget-title">Categories</h3>
                                <ul className="list-arrow">
                                    <li><a href="service-single.html">Measurement</a></li>
                                    <li><a href="service-single.html">Energy</a></li>
                                    <li><a href="service-single.html">Metering</a></li>
                                    <li><a href="service-single.html">Construction</a></li>
                                    <li><a href="service-single.html">Industries</a></li>
                                </ul>
                            </div>{/* Col end */}
                        </div>{/* Row end */}
                    </div>{/* Container end */}
                </div>{/* Footer main end */}
                <div className="copyright">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <div className="copyright-info text-center">
                                    <span>© Adilite Group, All rights reserved. <br/>Designed &amp; Developed by <a href="https://www.mirasung.com" target="_blank" alt="Mirasung Technologies Private Limited">Mirasung Technologies Private Limited</a>
                                    </span>
                                </div>
                            </div>
                        </div>{/* Row end */}
                        <div id="back-to-top" data-spy="affix" data-offset-top={10} className="back-to-top position-fixed">
                            <button className="btn btn-primary" title="Back to Top">
                                <i className="fa fa-angle-double-up" />
                            </button>
                        </div>
                    </div>{/* Container end */}
                </div>{/* Copyright end */}
            </footer>{/* Footer end */}
        </div>
    );
}

export default Footer;
